export {
  Loading,
  type LoadingProps as MkLoadingProps,
  WM_LOADING_DEFAULTS as LOADING_DEFAULTS,
  CW_LOADING_DEFAULTS as LOADING_DEFAULTS_WYNDHAM,
  LOADING_PROPS,
  type BrandType,
  getLoadingProps,
} from './Loading'
export { Loader, type LoaderProps as MkLoaderProps } from './loaders/Loader'
